export const messages = {
    "wr-dashboard.search.input.hint": "搜索",
    "wr-dashboard.search.label.breadcrumb": "搜索结果",
    "wr-dashboard.search.message.empty": "没有搜索到匹配的项目",
    "wr-dashboard.side-bar.selected.title:plural": "{count} 个项目已选定 | {count} 个项目已选定",
    "wr-dashboard.side-bar.backup-type.disk": "磁盘",
    "wr-dashboard.side-bar.backup-type.file": "文件",
    "wr-dashboard.side-bar.backup-type.notarized": "公证的文件和文件夹",
    "wr-dashboard.side-bar.backup-type.exchange": "应用程序 - Microsoft Exchange",
    "wr-dashboard.side-bar.backup-type.sql": "应用程序 - Microsoft SQL",
    "wr-dashboard.side-bar.backup-type.sys-state": "应用程序 - 系统状态",
    "wr-dashboard.side-bar.backup-type.application": "应用程序",
    "wr-dashboard.backups-table.column.name": "名称",
    "wr-dashboard.backups-table.column.size": "大小",
    "wr-dashboard.backups-table.column.version": "上一个版本",
    "wr-dashboard.backups-table.action.delete": "删除",
    "wr-dashboard.backups-table.message.no-backups": "云中尚未有备份",
    "wr-dashboard.backups-sidebar.label.size": "大小",
    "wr-dashboard.backups-sidebar.label.type": "类型",
    "wr-dashboard.backups-sidebar.label.version": "上一个版本",
    "wr-dashboard.backups-sidebar.label.created": "创建时间",
    "wr-dashboard.backups-sidebar.label.machine": "计算机",
    "wr-dashboard.backups-sidebar.label.owner": "所有者",
    "wr-dashboard.content-table.column.name": "名称",
    "wr-dashboard.content-table.column.versions": "版本",
    "wr-dashboard.content-table.column.volumes": "卷标",
    "wr-dashboard.content-table.column.path": "路径",
    "wr-dashboard.content-table.column.size": "大小",
    "wr-dashboard.content-table.column.version": "上一个版本",
    "wr-dashboard.content-table.action.notary-verify": "验证",
    "wr-dashboard.content-table.action.notary-get-crt": "获取证书",
    "wr-dashboard.content-table.action.asign": "发送以签名",
    "wr-dashboard.content-table.action.versions": "版本",
    "wr-dashboard.content-table.action.restore": "下载",
    "wr-dashboard.content-table.label.size": "大小",
    "wr-dashboard.content-table.label.created": "创建时间",
    "wr-dashboard.content-table.label.modified": "修改时间",
    "wr-dashboard.content-table.message.empty-folder": "此文件夹为空",
    "wr-dashboard.password-dialog-box.title.backup": "加密备份",
    "wr-dashboard.password-dialog-box.title.archive": "加密存档",
    "wr-dashboard.password-dialog-box.message.backup": "请指定备份 {displayName} 的访问密码",
    "wr-dashboard.password-dialog-box.message.archive": "请指定存档 {displayName} 的访问密码",
    "wr-dashboard.password-dialog-box.hint.password": "密码",
    "wr-dashboard.password-dialog-box.message.invalid-password": "密码不正确",
    "wr-dashboard.form.button.open": "打开",
    "wr-dashboard.form.button.close": "关闭",
    "wr-dashboard.form.button.cancel": "取消",
    "wr-dashboard.form.button.continue": "继续",
    "wr-dashboard.form.button.proceed": "继续",
    "wr-dashboard.form.button.delete": "删除",
    "wr-dashboard.form.button.done": "完成",
    "wr-dashboard.form.button.retry": "重试",
    "wr-dashboard.notary.verify.view.status.downloading": "正在下载...",
    "wr-dashboard.notary.verify.view.status.validating": "正在验证...",
    "wr-dashboard.notary.verify.view.status.pending": "正在等待证书...",
    "wr-dashboard.notary.verify.view.status.fail": "证书不匹配...",
    "wr-dashboard.notary.verify.view.button.get-crt": "获取证书",
    "wr-dashboard.notary.verify.view.file-info.name": "名称",
    "wr-dashboard.notary.verify.view.file-info.signed-by": "签名者",
    "wr-dashboard.notary.verify.view.file-info.date-backed-up": "备份日期",
    "wr-dashboard.notary.verify.view.file-info.date-notarized": "公证日期",
    "wr-dashboard.notary.verify.view.button.cancel": "取消",
    "wr-dashboard.notary.verify.view.button.done": "完成",
    "wr-dashboard.notary.warning.unsupported.browser.version": "不受支持的浏览器版本",
    "wr-dashboard.versions-dialog-box.title": "{fileName} 的版本",
    "wr-dashboard.asign-dialog-box.title": "发送以签名",
    "wr-dashboard.asign-dialog-box.message": "文件版本已共享，但无人可以查看，因为没有此版本链接。转到 ASign 以添加签名者并共享链接。",
    "wr-dashboard.asign-dialog-box.button.show-signed-file-details": "显示文件详细信息",
    "wr-dashboard.page-not-found.title": "未找到页面",
    "wr-dashboard.page-not-found.message.main": "找不到您要查找的页面。",
    "wr-dashboard.page-not-found.message.description": "链接可能已过期，或者键入的地址不正确。",
    "wr-dashboard.page-not-found.message.error": "错误代码：404",
    "wr-dashboard.server-error.title": "服务器不可用",
    "wr-dashboard.server-error.message": "服务器暂时不可用。请稍后再试。",
    "wr-dashboard.server-error.message.error": "错误代码：500",
    "wr-dashboard.account-menu.action.sign-out": "注销",
    "wr-dashboard.breadcrumb.item.machines": "计算机",
    "wr-dashboard.breadcrumb.item.failed-backups": "失败备份",
    "wr-dashboard.machines-table.column.name": "名称",
    "wr-dashboard.machines-table.column.size": "大小",
    "wr-dashboard.machines-table.message.no-machines": "在云中还没有计算机",
    "wr-dashboard.incomplete-backups.message.status:plural": "您有 {count} 失败备份或不完整备份，占用 {size} 存储空间 | 您有 {count} 失败备份或不完整备份，占用 {size} 存储空间",
    "wr-dashboard.incomplete-backups.button.view": "查看备份",
    "wr-dashboard.incomplete-backups.button.delete": "删除备份",
    "wr-dashboard.machines-table.message.space-used:plural": "全部备份使用情况{size}",
    "wr-dashboard.delete-archive-dialog-box.title": "删除存档",
    "wr-dashboard.delete-incomplete-archive-dialog-box.title": "删除不完整文件",
    "wr-dashboard.delete-all-incomplete-archives-dialog-box.title": "删除全部不完整文件",
    "wr-dashboard.delete-archive.message": "是否确定要从所有位置永久删除所选存档？所有这些数据都将被删除，并且无法恢复。",
    "wr-dashboard.delete-archive.deletion-warning-message": "如果保护中控台的相应工作负载未联机，也没有任何代理程序联机处理更改，则在此 Web Restore 中控台中进行的任何更改可能不会直观地反映在该工作负载中",
    "wr-dashboard.delete-archive.locked-error-message": "存档已锁定，以确保数据一致性。请终止对存档的所有操作（例如，浏览、恢复、备份），然后重试。",
    "wr-dashboard.certificate-pending-dialog-box.title": "证书待处理",
    "wr-dashboard.certificate-pending-dialog-box.message": "请在几分钟后重试。",
    "wr-dashboard.form.button.ok": "确定"
};
